import type React from 'react';

interface HeadProps {
  title: string;
  text: string;
}

export const Head: React.FC<HeadProps> = ({ title, text }) => {
  return (
    <div className="font-roboto">
      <h1 className="m-0 text-[25px] font-bold leading-[29px] text-black">{title}</h1>
      <p className="m-0 mt-[3px] text-[18px] font-normal leading-[23px] text-black">{text}</p>
    </div>
  );
};
